import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import store from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { injectStore } from "./api/config-pdfco";
import { ErrorBoundary } from "react-error-boundary";
import ReactErrorBoundary from "./components/reactErrorBoundary";
import TagManager from 'react-gtm-module';
import { GOOGLE_TAG_MANAGER_CONTAINER_ID } from './constants/common';

injectStore(store);

TagManager.initialize({
  gtmId: GOOGLE_TAG_MANAGER_CONTAINER_ID,
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary FallbackComponent={ReactErrorBoundary}>
        <App />
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
